export default class Faq {
  accordionItems: NodeListOf<HTMLElement>;
  activeClass: string;

  constructor(containerSelector: string) {
    this.accordionItems = document.querySelectorAll(
      `${containerSelector} .faq__item`
    ) as NodeListOf<HTMLElement>;
    this.activeClass = "active";
    this.init();
  }

  toggleAccordion(item: HTMLElement): void {
    item.classList.toggle(this.activeClass);
  }

  addAccordionEvent(): void {
    this.accordionItems.forEach((item) => {
      const button = item.querySelector(".faq__question") as HTMLElement;
      if (button) {
        button.addEventListener("click", () => this.toggleAccordion(item));
      }
    });
  }

  init(): void {
    if (this.accordionItems.length) {
      this.addAccordionEvent();
      this.toggleAccordion(this.accordionItems[0]);
    }
  }
}
